// extracted by mini-css-extract-plugin
export default {"container":"qvWPb","image":"BVNdq"};